var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrosssvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.134 6.88217H7.448V11.6342H5.578V6.88217H0.914V5.18817H5.578V0.414171H7.448V5.18817H12.134V6.88217Z",
    fill: "#FF4343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosssvg);
export default __webpack_public_path__ + "static/media/cross.svg.429325f6e015773372a441ef4df52fba.svg";
export { ForwardRef as ReactComponent };